<template>
    <div class="flex flex-col gap-2 w-full">
        <UAlert
            v-if="missingAccounts && missingAccounts > 0"
            color="error"
            variant="subtle"
            :title="`Kontoer mangler i systemet (${missingAccounts})`"
            icon="i-ph-warning-circle"
            orientation="horizontal"
            :actions="[
                {
                    label: `Opprett konto (${missingAccounts})`,
                    color: 'neutral',
                    class: 'border border-base-content text-base-content shadow-none ring-0',
                    variant: 'outline',
                    onClick: createMissingAccounts
                }
            ]"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />

        <UAlert
            v-if="misnamedAccounts && misnamedAccounts > 0"
            color="warning"
            variant="subtle"
            :title="`Kontoer har avvikende navn mot system (${misnamedAccounts})`"
            icon="i-ph-warning"
            orientation="horizontal"
            :actions="[
                {
                    label: `Endre navn (${misnamedAccounts})`,
                    color: 'neutral',
                    class: 'border border-base-content text-base-content shadow-none ring-0',
                    variant: 'outline',
                    onClick: correctMisnamedAccounts
                }
            ]"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />

        <UAlert
            v-if="inactiveAccounts && inactiveAccounts > 0"
            color="warning"
            variant="subtle"
            :title="`Kontoer er inaktiv(${inactiveAccounts})`"
            icon="i-ph-warning"
            orientation="horizontal"
            :actions="[
                {
                    label: `Aktiver konto (${inactiveAccounts})`,
                    color: 'neutral',
                    class: 'border border-base-content text-base-content shadow-none ring-0',
                    variant: 'outline',
                    onClick: activateAllInactiveAccounts
                }
            ]"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />

        <UAlert
            v-if="mismatchedVatCodes && mismatchedVatCodes > 0"
            color="warning"
            variant="subtle"
            :title="`Kontoer har avvikende MVA-koder mot system (${mismatchedVatCodes})`"
            icon="i-ph-warning"
            orientation="horizontal"
            :actions="[
                {
                    label: `Endre MVA-kode (${mismatchedVatCodes})`,
                    color: 'neutral',
                    class: 'border border-base-content text-base-content shadow-none ring-0',
                    variant: 'outline',
                    onClick: correctMismatchedVatCodes,
                }
            ]"
            :ui="{
                root: 'p-2',
                icon: 'size-6',
            }"
        />
    </div>
</template>

<script setup lang="ts">

import useTrialBalance from '@/incoming-balance/tribal.composable'
const {
    missingAccounts, createMissingAccounts,
    misnamedAccounts, correctMisnamedAccounts,
    inactiveAccounts, activateAllInactiveAccounts,
    mismatchedVatCodes, correctMismatchedVatCodes
} = useTrialBalance()

</script>

<style scoped>

</style>